import gql from 'graphql-tag';

export const FRESH_ARTICLES_WITH_CREATIVES_COUNT_QUERY = gql`
  query FreshArticlesWithCreativesCountQuery(
    $campaignIds: [ID!]!
    $startDate: String!
    $endDate: String!
    $deprecated: Boolean!
  ) {
    freshArticles(campaignIds: $campaignIds, startDate: $startDate, endDate: $endDate, deprecated: $deprecated) {
      id
      eligibleCreativesWithoutAds {
        id
      }
    }
  }
`;

export const FRESH_ARTICLES_QUERY = gql`
  query FreshArticlesQuery($campaignIds: [ID!]!, $startDate: String!, $endDate: String!, $deprecated: Boolean!) {
    freshArticles(campaignIds: $campaignIds, startDate: $startDate, endDate: $endDate, deprecated: $deprecated) {
      id
      title
      url
      campaignId
      createdAt
      expirationTime
      publishTime
      instantArticleMessage
      facebookActiveAdsCount
      facebookAdsCount
      facebookLastAdsUploadedAt
      googleLastAdsUploadedAt
      deprecated
      starred
      facebookPageId
      facebookPage {
        id
        facebookPageId
        facebookPageDisplayName
      }
      googleAdsCount
      articleGroup {
        id
        articleGroupOgTags {
          ogArticlePublishedTime
        }
      }
      campaign {
        name
        savedAudienceId
        useSavedAudience
        publisher {
          name
          publisherFacebookAccounts {
            priority
            facebookAccount {
              accountId
              businessId
            }
          }
          facebookAccounts {
            accountId
            timezone
          }
        }
      }
      keyweeFacebookCampaigns {
        facebookCampaignId
        adsManagerUrl
        facebookState
      }
      storyAudienceMetrics {
        pending
        successful
        failed
        expired
      }
    }
  }
`;
